@if (loading) {
  <div class="text-center pt-5">
    <app-loading-spinner></app-loading-spinner>
  </div>
}
@if (!loading) {
  <div class="row g-4 mb-3">
    <div class="col-sm-auto">
      <div>
        <a routerLink="/baselines/create" class="btn btn-success">
          <i class="ri-add-line align-bottom me-1"></i> Add New
        </a>
      </div>
    </div>
    <div class="col-sm">
      <div class="d-flex justify-content-sm-end gap-2">
        <div class="search-box ms-2">
          <input type="text" class="form-control" placeholder="Search..." [(ngModel)]="searchText" (ngModelChange)="onSearch()">
          <i class="ri-search-line search-icon"></i>
        </div>
      </div>
    </div>
  </div>
  @if (questionnaireBaselines.length === 0) {
    <div class="row">
      <div class="col-12 text-center">
        <h3 class="text-muted">No Questionnaire Baselines has been found</h3>
      </div>
    </div>
  }
  @if (questionnaireBaselines.length > 0) {
    <div class="row">
      @for (data of questionnaireBaselines; track data) {
        <div class="col-xxl-3 col-sm-6 project-card">
          <div class="card" style="height: 275px;">
            <div class="card-body">
              <div class="p-3 mt-n3 mx-n3 bg-info-subtle text-info rounded-top">
                <div class="d-flex align-items-center">
                  <div class="flex-grow-1">
                    <h5 class="mb-0 fs-14">
                      <a class="text-body">{{ data.name }}</a>
                    </h5>
                  </div>
                  <div class="flex-shrink-0">
                    <div class="d-flex gap-1 align-items-center my-n2">
                      <div class="dropdown" ngbDropdown>
                        <button class="dropdown-toggle btn btn-link text-muted p-0 text-decoration-none arrow-none" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true" ngbDropdownToggle>
                          <i class="ri-more-2-fill ri-lg align-middle"></i>
                        </button>
                        <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                          <a class="dropdown-item" (click)="openViewBaselineModal(data.id)">
                            <i class="ri-eye-fill align-bottom me-2 text-muted float-start"></i> View </a>
                            <a class="dropdown-item" routerLink="/baselines/edit/{{ data.id }}">
                              <i class="ri-pencil-fill align-bottom me-2 text-muted float-start"></i> Edit </a>
                              <div class="dropdown-divider"></div>
                              <a class="dropdown-item" (click)="openDeleteQuestionModal(data)">
                                <i class="ri-delete-bin-fill align-bottom me-2 text-muted float-start"></i> Remove </a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="py-3">
                      <div class="row gy-3">
                        <div class="col-4">
                          <div>
                            <p class="text-muted mb-1">Status</p>
                            <div class="badge bg-{{ listStatus[data.status] }}-subtle text-{{ listStatus[data.status] }} fs-12">
                              {{ data.status }}
                            </div>
                          </div>
                        </div>
                        <div class="col-4">
                          <div>
                            <p class="text-muted mb-1">Last Update</p>
                            <h5 class="fs-14">{{data.updatedAt === data.createdAt ? 'No Update' : data.updatedAt | date:'medium'}}</h5>
                          </div>
                        </div>
                        <div class="col-4">
                          <div>
                            <p class="text-muted mb-1">Questions</p>
                            <h5 class="fs-14">{{ data.question_count}}</h5>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="py-3">
                      <div class="row gy-3">
                        <div class="col-12">
                          <div>
                            <p class="text-muted mb-1">Description</p>
                            <div class="ql-container ql-snow" style="border-width: 0;">
                              <div class="ql-editor p-0" [innerHTML]="data.description ? (data.description | truncate:150) : data.description"></div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        }
        @if (questionnaireBaselines && questionnaireBaselines.length > pageSize) {
          <div class="row justify-content-md-between align-items-md-center">
            <div class="col col-sm-6">
              <div class="dataTables_info mb-2" id="tickets-table_info" role="status" aria-live="polite"> Showing {{startIndex}} to {{endIndex}} of {{total}} entries </div>
            </div>
            <div class="col col-sm-6">
              <div class="text-sm-right float-end listjs-pagination">
                <ngb-pagination [collectionSize]="total" [(page)]="currentPage" [pageSize]="pageSize" (pageChange)="getQuestionnaireBaselines()"></ngb-pagination>
              </div>
            </div>
          </div>
        }
      }

      <ng-template #deleteBaselineModal let-modal>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="btn-close" (click)="modal.close('Close click')"></button>
          </div>
          <div class="modal-body">
            <div class="mt-2 text-center">
              <lord-icon src="https://cdn.lordicon.com/gsqxdxog.json" trigger="loop" colors="primary:#f7b84b,secondary:#f06548" style="width:100px;height:100px"></lord-icon>
              <div class="alert alert-danger">
                <p class="mb-0 text-uppercase">Once done, this action cannot be undone!!!</p>
              </div>
              <div class="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
                <h4>Are you Sure You want to delete</h4>
                <h4><span class="fw-semibold text-warning">{{ selectedBaseline.name }}</span>?</h4>
              </div>
            </div>
            <div class="d-flex gap-2 justify-content-center mt-4 mb-2">
              <button type="button" class="btn w-sm btn-light" data-bs-dismiss="modal" (click)="modal.close('Close click')">Close</button>
              <button type="button" class="btn w-sm btn-danger btn-load" (click)="deleteBaseline()">
                <span class="d-flex justify-content-center">
                  @if (submitted && spinner) {
                    <span class="spinner-border" role="status">
                      <span class="visually-hidden">Loading...</span>
                    </span>
                  }
                  <span [ngClass]="submitted && spinner ? 'ms-2' : ''">Yes, Delete It!</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #successModal let-modal>
        <div class="modal-content">
          <div class="modal-body text-center p-5">
            <div class="text-end">
              <button class="btn-close text-end" data-bs-dismiss="modal" aria-label="Close" (click)="closeModal()"></button>
            </div>
            <div class="mt-2">
              @if (success) {
                <lord-icon src="https://cdn.lordicon.com/tqywkdcz.json" trigger="hover" style="width:150px;height:150px"></lord-icon>
              }
              @if (!success) {
                <lord-icon src="https://cdn.lordicon.com/tdrtiskw.json" trigger="loop" colors="primary:#f06548,secondary:#f7b84b" style="width:120px;height:120px"></lord-icon>
              }
              <h4 class="mb-3 mt-4">{{ successMessage }}</h4>
              @if (!success) {
                <p class="text-muted mx-4 mb-0">{{ message }}</p>
              }
            </div>
          </div>
        </div>
      </ng-template>

      <ng-template #viewBaselineModal let-modal>
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="modal.close('Close click')"></button>
          </div>
          <div class="modal-body w-100 p-4 questionaireBg" [ngClass]="selectedBaseline.lang_code === 'he' ? 'rtl' : 'ltr'">

            @if (showDesc) {
              <div>
                <h4 class="font-weight-bold">{{ 'ASSESSMENTAPP.DESCRIPTION' | translate}}</h4>
                <div class="ql-container ql-snow" style="border-width: 0;">
                  <div class="ql-editor" [innerHTML]="selectedBaseline.description"></div>
                </div>
                @if (!selectedBaseline.description) {
                  <div>
                    <h5>No description has been added</h5>
                  </div>
                }
              </div>
            }

            @if (showQuestion) {
              <div class="questionaireSectionMain">
                <app-view-chapter-question [question_index]="questionIndex" [question_length]="selectedBaseline.baseline_questions.length" [chapter_name]="'baseline'" [lang_code]="selectedBaseline.lang_code" [question]="currentViewQuestion" [questionID]="'question-' + questionIndex"></app-view-chapter-question>
              </div>
            }

            <div class="btn-group w-100 pt-4" [ngClass]="selectedBaseline.lang_code === 'he' ? 'rtl' : 'ltr'">
              <div>
                @if (showQuestion) {
                  <button (click)="backQuestion()" type="button" class="btn btn-secondary">{{ 'ASSESSMENTAPP.BACK' | translate}}</button>
                }
              </div>
              @if (showNext && selectedBaseline.baseline_questions.length > 0) {
                <div [ngClass]="selectedBaseline.lang_code === 'he' ? 'me-auto' : 'ms-auto'">
                  <button (click)="nextQuestion()" type="button" class="btn btn-secondary">{{ 'ASSESSMENTAPP.NEXT' | translate}}</button>
                </div>
              }
            </div>
          </div>
        </div>
      </ng-template>